export function userHasPermission(feature: string, permissions: string[]) {
  if (!permissions) return false;

  if (permissions.includes("admin") || permissions.includes(feature)) {
    return true;
  } else {
    return false;
  }
}
